<template>
  <report-section 
    title="心率间隔散点图" 
    class="rr-scatter-section"
  >
    <template v-slot:content>
      <div class="chart-container">
        <div class="scatter-chart" :id="chartId"></div>
      </div>
    </template>
  </report-section>
</template>

<script>
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";

export default {
  components: {
    ReportSection
  },

  props: {
    reportDetailModel: Object,
  },

  data() {
    return {
      chartId: "rrScatterChart",
      chart: null
    };
  },

  mounted() {
    this.$nextTick(() => {
      const chartDom = document.getElementById(this.chartId);
      if (chartDom) {
        this.chart = this.$echarts.init(chartDom);
        this.drawScatter();
      }
    });
  },

  watch: {
    reportDetailModel() {
      if (this.chart) {
        this.drawScatter();
      }
    },
  },

  methods: {
    drawScatter() {
      const scatterData = this.getRRIntervalData();
      
      const option = {
        grid: {
          left: '10%',
          right: '12%',
          top: '10%',
          bottom: '20%'
        },
        xAxis: {
          type: 'value',
          name: '(ms)',
          nameLocation: 'end',
          nameGap: 15,
          nameTextStyle: {
            color: '#333',
            fontSize: 14
          },
          min: 0,
          max: 1488,
          interval: 372,
          axisLine: {
            lineStyle: {
              color: '#BABABA'
            }
          },
          axisLabel: {
            color: '#666',
            margin: 10
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#f0f0f0',
              type: 'solid'
            }
          }
        },
        yAxis: {
          type: 'value',
          name: '(ms)',
          nameLocation: 'end',
          nameGap: 15,
          nameTextStyle: {
            color: '#333',
            fontSize: 14
          },
          min: 0,
          max: 1494,
          interval: 166,
          axisLine: {
            lineStyle: {
              color: '#BABABA'
            }
          },
          axisLabel: {
            color: '#666',
            margin: 10
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#f0f0f0',
              type: 'solid'
            }
          }
        },
        series: [{
          name: 'RR Interval',
          data: scatterData,
          type: 'scatter',
          symbolSize: 2,
          itemStyle: {
            opacity: 0.8,
            color: '#ff4444'
          }
        }],
        tooltip: {
          trigger: 'item',
          formatter: function(params) {
            return `RR(n): ${params.data[0]}ms<br/>RR(n+1): ${params.data[1]}ms`;
          }
        }
      };

      this.chart.setOption(option);
    },

    getRRIntervalData() {
      
      if (this.reportDetailModel?.hrvScatterData && Array.isArray(this.reportDetailModel.hrvScatterData) && this.reportDetailModel.hrvScatterData.length > 0) {
        console.log('hrvScatterData',this.reportDetailModel.hrvScatterData)
        return this.reportDetailModel.hrvScatterData;
      }
      
      // 如果没有真实数据，返回空数组
      return [];
    }
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
};
</script>

<style lang="scss" scoped>
.rr-scatter-section {
  /deep/ .report-section-title-text {
    @include report-section-title;
  }
}

.chart-container {
  position: relative;
  width: 100%;
  height: 320px;
}

.scatter-chart {
  @include z-index-2;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

@media print {
  .rr-scatter-section {
    /deep/ .report-section-title-text {
      @include report-section-title-print;
    }
  }
  
  .chart-container {
    height: 250px;
  }
}
</style>
